// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Pd4Y","error":"Textarea_error__AsN4-","readonly":"Textarea_readonly__1VG1Y","disabled":"Textarea_disabled__isHZP"};